import React from "react";
import { Link } from "react-router-dom";
import { Plus } from "lucide-react";
import { useI18n } from "@/lib/i18n";
import { btnPrimary } from "@/components/Brand";

/** Page title, the trial usage pill and the new-gallery button. */
export const DashboardHeading = ({ trial, projectCount, onNew }) => {
  const { t } = useI18n();

  return (
    <div className="flex flex-wrap items-end justify-between gap-6 mb-12">
      <div>
        <p className="eyebrow mb-3">{t("dashboard")}</p>
        <h1 className="text-4xl sm:text-5xl tracking-tighter font-medium">{t("projects")}</h1>
      </div>
      <div className="flex items-center gap-5">
        {trial && (
          <Link to="/billing" data-testid="trial-indicator"
            className="font-mono-accent text-[10px] tracking-[0.16em] uppercase border border-[#D4AF37]/40 text-[#D4AF37] px-3 py-2 hover:bg-[#D4AF37]/10 transition-colors">
            {projectCount}/{trial.max_projects} {t("projects")} · {trial.days_left} {t("trial_days_left")}
          </Link>
        )}
        <button data-testid="new-project-btn" onClick={onNew} className={btnPrimary}>
          <Plus size={14} /> {t("new_project")}
        </button>
      </div>
    </div>
  );
};
